/*
 * @Author: your name
 * @Date: 2020-08-12 13:50:29
 * @LastEditTime: 2021-07-14 10:12:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nvoicep-h5/src/axios/index.js
 */
import axios from 'axios'
import qs from 'qs'
// import mockConfig from './mockConfig'
import { Toast } from 'vant';
import { safeUrlBase64Encrypt, safeUrlBase64Decrypt  } from '@assets/lib/crypto.js'


var debug = process.env.NODE_ENV === 'production'?'':'&debug=true'
//创建axios实例
const instance = axios.create({
  timeout: 10000, // 超时
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'x-reqe1f2a3b4': true,
    'x-accrespf5g6h7i8': true,
  },
  transformRequest: [function (data) {
    return qs.stringify(data)
  }]
})

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  let sign = sessionStorage.getItem('sign')
  let token= sessionStorage.getItem('token')
  let city_id= sessionStorage.getItem('city_id')
  let ut = sessionStorage.getItem('user_type')
  let su = new Date().getTime()

  let encrypt_switch = sessionStorage.getItem('encrypt_switch')
  // 用户类型
  let userType = ''
  // 入口类型
  let entrance_type = ''

  switch(ut){
    //  1 企业小b  2 一次性开票小b  3 零担  4小b个人 5企业 6微信小程序 7用户企业或个人
    case '1':
      userType=2,
      entrance_type=3
      break;
    case '2':
      userType=2,
      entrance_type=1
      break;
    case '3':  
      userType=3,
      entrance_type=2
      break;
    case '4':  
      userType=2,
      entrance_type=2
      break;
    case '5':  
      userType=1,
      entrance_type=4
      break;
    case '6':  
      userType=2,
      entrance_type=5
      break;
    case '7':  
      userType=1,
      entrance_type=4
      break; 
    case '8':  //小拉app
      userType=4,
      entrance_type=7
      break; 
    case '9':  //小拉微信
      userType=4,
      entrance_type=5
      break; 
    case '14':  //抖音微信
      userType = 4,
      entrance_type = 11
      break; 
    case '18': //货运app
      userType = 4,
      entrance_type = 15
      break;     
  }
  let url_a = config.url.substring(config.url.length - 9) //发票提交后进入提交中页面需要轮询ui_status接口不需要加载loading显示
  config.url = config.url+'&token='+token+'&user_type='+userType+'&entrance_type='+entrance_type+'&city_id='+city_id+'&sign='+sign+'&su='+su
  // 发送请求之前
  // 显示 loading
  if(config.method.toLowerCase() == 'post'){
    config.data = Object.assign({},config.data,{token:token,user_type:userType})

    const fields = ['ep_reg_contact', 'bank_account_no', 'tax_payer_identify_no', 'traveler_identity'];

    fields.forEach(field => {
      // 生成该字段的两种路径
      const paths = [
        ['data', field],
        ['data', 'data', field]
      ];

      const plaintext = paths
        .map(path => path.reduce((obj, key) => obj && obj[key], config))
        .find(Boolean);

      if (plaintext && encrypt_switch != 1) {
        const encrypted = safeUrlBase64Encrypt(plaintext);

        paths.forEach(path => {
          const lastKey = path[path.length - 1];
          if (config.data.data && config.data.data[lastKey]) {
            config.data.data = Object.assign({}, config.data.data, { [lastKey]: encrypted });
          } else if (config.data[lastKey]) {
            config.data = Object.assign({}, config.data, { [lastKey]: encrypted });
          }
        });
      }

    })
    
    if (encrypt_switch == 1) {
      delete config.headers['x-accrespf5g6h7i8'];
      delete config.headers['x-reqe1f2a3b4'];
    }
  }
  //页面元素出现多个toast
  Toast.clear()

  if(url_a != 'ui_status'){//ui_status接口不需要显示loading
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration:0
    });
  }
  return config;
}, function (error) {
  Toast.fail({
    message: '请求异常', // 多行用\n间隔
    duration: 2000 // 显示时间
  })
  // 对请求错误做些什么
  return Promise.reject(error);
})

// 添加响应拦截器
instance.interceptors.response.use(function (response) {

  Toast.clear()

  if(response.data.ret == '3001' || response.data.ret == '3004' || response.data.ret == '3010' || response.data.ret == '3011') { // 3020 是零担登录失效码
    console.log('app: e-huolala')
    window.location.href = 'http://e.huolala.cn/'
  }
  else if(response.data.ret == '3020'){
    window.location.href = 'http://ltl.huolala.cn/'
  }
  // else if(response.data.ret == '3021'){
  //   window.location.href = window.location.host +'/#/passport'
  // }
  // 清除loading


  if (response.data.ret == 0) {
    const headers = response.headers;
    const shouldDecrypt = headers['x-respj9k0l1m2'] == 'true' ? true : false;

    response.data.data = shouldDecrypt ? JSON.parse(safeUrlBase64Decrypt(response.data.data)) : response.data.data;
  }

  return response;
}, function (error) {
  // 对响应错误做点什么()
  console.log('返回错误',error)
  // 清除loading
  Toast.clear()
  return Promise.reject(error);
})

export default instance



// WEBPACK FOOTER //
// ./src/axios/index.js